import { useCallback, useEffect, useRef } from 'react';
import type Slider from 'react-slick';
import { createPreviewMessageEventHandler } from '@shared/utils/previewMessageBus';
import globalWindow from '@shared/core/globals';
import { SLIDER_BASE_SETTINGS } from '../PhotoSlider.config';

export const useSliderSettings = () => {
  const sliderRef = useRef<Slider | null>(null);

  const settings = { ...SLIDER_BASE_SETTINGS };

  const goToSlide = useCallback((slideIndex: number) => {
    sliderRef.current?.slickGoTo(slideIndex, true);
  }, []);

  useEffect(() => {
    const receiveMessage = createPreviewMessageEventHandler(message => {
      if (message.action === 'fromList') {
        message.value.forEach(result => {
          switch (result.key) {
            case 'sliderGoToSlideIndex':
              goToSlide(result.value);
              break;
          }
        });
      }
    });
    globalWindow.addEventListener?.('message', receiveMessage, false);
    return () => {
      globalWindow.removeEventListener?.('message', receiveMessage, false);
    };
  }, [goToSlide]);

  return { settings, sliderRef };
};
